<template>
  <hm-content title="">
    <div class="product-analysis">
      <div class="flex flex-between item-center ">
        <div class="title">历史复购数据汇总</div>
        <div style="margin-bottom: 18px;">
          <el-date-picker
            clearable
            :default-time="['00:00:00', '23:59:59']"
            v-model="createTimeArry"
            type="datetimerange"
            align="right"
            start-placeholder="请选择开始时间"
            end-placeholder="请选择结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            class="mr10"
            @change="createTimeArryChange"
          ></el-date-picker>
        </div>
      </div>
      <div class="funnel flex flex-column flex-center">
        <div
          class="flex-1 funnel-row flex flex-between"
          v-for="(v, i) in h"
          :key="i"
        >
          <div class="flex">
            <div
              class="flex flex-column flex-center data-info"
              :class="v.datalist.length - 1 > index ? 'bor-right' : ''"
              v-for="(j, index) in v.datalist"
              :key="index"
            >
              {{ j.title }}
              <div class="text-left">
                {{ j.val }}
                <span
                  v-if="i === 4 && (index === 0 || index === 1)"
                  class="primary"
                >
                  / {{ ToFixed(j.price, 2) }}
                </span>
              </div>
            </div>
          </div>

          <div
            class="flex flex-column flex-center tit"
            :class="i === 3 ? 'carts' : ''"
          >
            {{ v.name }}
          </div>
        </div>

        <div class="cover-purchase1">
          转化率
          <div>{{ ToFixed(purchase1, 2) }}%</div>
        </div>
        <div class="cover-purchase2">
          转化率
          <div>{{ ToFixed(purchase2, 2) }}%</div>
        </div>
        <div class="cover-purchase3">
          转化率
          <div>{{ ToFixed(purchase3, 2) }}%</div>
        </div>
        <div class="cover-purchase4">
          转化率
          <div>{{ ToFixed(purchase4, 2) }}%</div>
        </div>
        <div class="cover-purchase5">
          转化率
          <div>{{ ToFixed(purchase5, 2) }}%</div>
        </div>
      </div>
    </div>
    <div class="product-analysis">
      <div class="flex flex-between item-center">
        <div class="title">导购跟进明细</div>
        <div style="margin-bottom: 18px;">
          <el-cascader
            clearable
            class="mr10"
            ref="cascader"
            v-model="searchCondition.orgCode"
            :props="props"
            :show-all-levels="false"
            size="small"
            placeholder="请选择机构"
          ></el-cascader>
          <el-select
            size="small"
            clearable
            v-model="searchCondition.employeeId"
            filterable
            class="mr10"
            placeholder="请选择导购"
          >
            <el-option
              :label="item.realname"
              :value="item.employeeId"
              v-for="(item, index) in employeeIdAllList"
              :key="index"
            ></el-option>
          </el-select>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table
          @sort-change="sortChange"
          stripe
          border
          ref="table"
          :data="list"
          style="width: 100%"
          size="small"
          :default-sort="{ prop: 'num', order: 'descending' }"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realname"
            label="导购名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="workNum"
            label="账号"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="phone"
            label="手机号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="departName"
            label="所属机构"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="coverNum"
            label="覆盖复购人数"
            sortable
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="noticeNum"
            label="跟进人数"
            sortable
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="addCartNum"
            label="客户加购物车人数"
            sortable
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="payNum"
            label="付款人数"
            sortable
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="totalPayPrice"
            label="付款金额"
            sortable
          >
            <template slot-scope="scope">
              <div class="primary">
                {{ ToFixed(scope.row.totalPayPrice, 2) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="repurchaseRatio"
            label="复购转化率"
            sortable
          >
            <template slot-scope="scope">
              {{ ToFixed(scope.row.repurchaseRatio, 2) }}%
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button
                  size="small"
                  type="text"
                  @click="toDetails(scope.row)"
                  >查看明细</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { ToFixed } from "@/utils/utils";
export default {
  data() {
    return {
      employeeIdAllList: [],
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "store"
              })
              .then(res => {
                res.result.records.forEach(v => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.orgCode;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryOrganizationListByParent", {
                parentId: data.treeStruct
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      createTimeArry: [],
      ToFixed,
      list: [],
      h: [
        {
          name: "覆盖人数",
          datalist: [
            {
              title: "覆盖复购总人数",
              val: 0
            }
          ]
        },
        {
          name: "通知人数",
          datalist: [
            {
              title: "系统提醒通知人数",
              val: 0
            },
            {
              title: "导购跟进通知人数",
              val: 0
            }
          ]
        },
        {
          name: "访问人数",
          datalist: [
            {
              title: "系统通知访问人数",
              val: 0
            },
            {
              title: "导购通知访问人数",
              val: 0
            }
          ]
        },
        {
          name: "客户加购物车",
          datalist: [
            {
              title: "系统通知加购人数",
              val: 0
            },
            {
              title: "导购通知加购人数",
              val: 0
            }
          ]
        },
        {
          name: "付款人数",
          datalist: [
            {
              title: "系统通知付款人数/金额",
              val: 0,
              price: 0
            },
            {
              title: "导购通知付款人数/金额",
              val: 0,
              price: 0
            }
            // {
            //   title: "系统通知付款金额",
            //   val: 0
            // },
            // {
            //   title: "导购通知付款金额",
            //   val: 0
            // }
          ]
        }
      ],
      purchase1: 0,
      purchase2: 0,
      purchase3: 0,
      purchase4: 0,
      purchase5: 0,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      sort: {}
    };
  },
  created() {},
  mounted() {
    this.queryRepurchaseStatistics();
    this.queryAllEmployee();
    this.queryList();
  },
  methods: {
    toDetails(row) {
      let params = JSON.stringify({
        realname: row.realname,
        workNum: row.workNum,
        phone: row.phone,
        departName: row.departName,
        employeeId: row.employeeId,
        queryStartTime: this.isArray(this.createTimeArry)
          ? this.createTimeArry[0]
          : "",
        queryEndTime: this.isArray(this.createTimeArry)
          ? this.createTimeArry[1]
          : ""
      });
      this.$router.push({
        name: "ProductAnalysis",
        query: {
          params
        }
      });
    },
    sortChange(sort) {
      if (sort.order === "descending") {
        sort.order = "desc";
      } else if (sort.order === "ascending") {
        sort.order = "asc";
      }
      this.sort = sort;
      this.queryList();
    },
    async queryAllEmployee() {
      const { result } = await this.$store.dispatch("queryEmployee", {
        pageNo: 1,
        pageSize: 9999,
        loginType: "store",
        workingState: "yes"
      });
      this.employeeIdAllList = result.records;
    },
    createTimeArryChange() {
      this.queryRepurchaseStatistics();
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryRepurchaseStatistics() {
      let params = {
        queryStartTime: this.isArray(this.createTimeArry)
          ? this.createTimeArry[0]
          : "",
        queryEndTime: this.isArray(this.createTimeArry)
          ? this.createTimeArry[1]
          : ""
      };
      const { result } = await this.$store.dispatch(
        "queryRepurchaseStatistics",
        params
      );
      this.h.forEach((item, index) => {
        if (index === 0) {
          item.datalist.forEach(v => {
            v.val = result.totalCoverNum;
          });
        } else if (index === 1) {
          item.datalist[0].val = result.noticeNum;
          item.datalist[1].val = result.employeeNoticeNum;
        } else if (index === 2) {
          item.datalist[0].val = result.visitNum;
          item.datalist[1].val = result.employeeVisitNum;
        } else if (index === 3) {
          item.datalist[0].val = result.addCartNum;
          item.datalist[1].val = result.employeeAddCartNum;
        } else if (index === 4) {
          item.datalist[0].val = result.payNum;
          item.datalist[0].price = result.payPrice;
          item.datalist[1].val = result.employeePayNum;
          item.datalist[1].price = result.employeePayPrice;
        }
      });
      this.purchase1 = result.totalCoverNum
        ? ((result.noticeNum + result.employeeNoticeNum) /
            result.totalCoverNum) *
          100
        : 0;
      this.purchase2 =
        result.noticeNum + result.employeeNoticeNum
          ? ((result.visitNum + result.employeeVisitNum) /
              (result.noticeNum + result.employeeNoticeNum)) *
            100
          : 0;
      this.purchase3 =
        result.visitNum + result.employeeVisitNum
          ? ((result.addCartNum + result.employeeAddCartNum) /
              (result.visitNum + result.employeeVisitNum)) *
            100
          : 0;
      this.purchase4 =
        result.addCartNum + result.employeeAddCartNum
          ? ((result.payNum + result.employeePayNum) /
              (result.addCartNum + result.employeeAddCartNum)) *
            100
          : 0;
      this.purchase5 = result.totalCoverNum
        ? ((result.payNum + result.employeePayNum) / result.totalCoverNum) * 100
        : 0;
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        orderByValue: this.sort.order,
        orderByType:
          this.sort.prop === "totalPayPrice" ? "payPrice" : this.sort.prop,
        queryStartTime: this.isArray(this.createTimeArry)
          ? this.createTimeArry[0]
          : "",
        queryEndTime: this.isArray(this.createTimeArry)
          ? this.createTimeArry[1]
          : ""
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.orgCode = this.isArray(this.searchCondition.orgCode)
        ? this.searchCondition.orgCode[this.searchCondition.orgCode.length - 1]
        : "";

      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryRepurchaseEmployeeFollowMemberStatistics",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.product-analysis {
  margin-bottom: 10px;
  padding: 10px;
  .title {
    color: #222222;
    font-weight: bold;
    margin-bottom: 18px;
    font-size: 16px;
    &::before {
      display: inline-block;
      margin-right: 5px;
      content: "";
      width: 4px;
      height: 14px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.funnel {
  background-image: url("https://imgcdn.hemiao100.com/ThemePictures/effectanalysisimg.png");
  height: 470px;
  background-size: 98% 100%;
  position: relative;
  background-repeat: no-repeat;

  .funnel-row {
    .data-info {
      font-size: 15px;
      line-height: 26px;
      margin: 20px 0;
      width: 210px;
      // text-align: center;
      padding-left: 30px;
      box-sizing: border-box;
      &.bor-right {
        border-right: 1px solid #ffb6d5;
      }
    }
    .tit {
      font-size: 18px;
      color: #fff;
      margin-right: 26%;
      white-space: nowrap;
      &.carts {
        margin-right: 24.5%;
      }
    }
  }

  .cover-purchase1 {
    position: absolute;
    top: 14%;
    right: 5.5%;
    font-size: 14px;
  }
  .cover-purchase2 {
    position: absolute;
    top: 36%;
    right: 7.9%;
    font-size: 14px;
  }
  .cover-purchase3 {
    position: absolute;
    bottom: 34%;
    right: 10.4%;
    font-size: 14px;
  }
  .cover-purchase4 {
    position: absolute;
    bottom: 12%;
    right: 12.5%;
    font-size: 14px;
  }
  .cover-purchase5 {
    position: absolute;
    transform: translate(-50%, -50%);
    right: 1%;
    top: 55%;
    font-size: 14px;
  }
}
</style>
